module.exports = __webpack_public_path__ + "files/tours.af8ea815aa807f78c352656290010949.pdf";